import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentViewComponent } from './equipment-view/equipment-view.component';
import { EquipmentFormComponent } from './equipment-form/equipment-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EquipmentRoutingModule } from './equipment-routing-module';



@NgModule({
  declarations: [
    EquipmentViewComponent,
    EquipmentFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    EquipmentRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class EquipmentModule { }
